export class IrpfListModel {

    uid: string;
    invoiceUid: string;
    invoiceNumber: string;
    issuer: string;
    issuerVat: string;
    receiver: string;
    receiverVat: string;
    date: Date;
    base: number;
    percent: number;
    amount: number;

    image: boolean;
    pdf: boolean;
    isInvoice: boolean;

    trimester: string;

    constructor() {

    }
}
